export default {
      id: "multivacancy-usage",
      viewBox: "0 0 11 13",
      url: __webpack_public_path__ + "sprite-46b249.svg#multivacancy-usage",
      toString: function () {
        return this.url;
      }
    }